import { render } from "./TeamResult.vue?vue&type=template&id=ed52b96a"
import script from "./TeamResult.vue?vue&type=script&lang=js"
export * from "./TeamResult.vue?vue&type=script&lang=js"

import "./TeamResult.vue?vue&type=style&index=0&id=ed52b96a&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__